'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useZoomHref", {
    enumerable: true,
    get: function() {
        return useZoomHref;
    }
});
function useZoomHref({ href }) {
    return href;
}

//# sourceMappingURL=useZoomHref.js.map
